import React, {Component} from "react";
import {Form, Errors, Control} from "react-redux-form";
import {isRequired, required, isEmail, isRfc, maxLength, isCurp} from "../field_validations";
import {allUpper, toInt} from "../parsers";
import _ from "lodash";
import {confirmAlert} from "react-confirm-alert";

export default class RegisterUser extends Component{
	render(){
		const {register} = this.props;
		let listData = !_.isEmpty(register.data) && register.data.modality_id ? _.find(register.modalities, {id: register.data.modality_id}):undefined;
		let roleList = listData ? listData.roles:[];
		let statesList = listData ? listData.states:[];
		let stateData = listData && listData.id === 2 && register.data.state_id ? _.find(statesList, {id: register.data.state_id }):undefined;
		let municipalitiesList = stateData ? stateData.municipalities:[];
		return (
			<div className="content">
				<p className="is-size-5 has-text-left">Registro de usuario</p>

				{register.error && <p className="has-text-centered help is-danger">{register.error}</p>}
				{register.message && <p className="has-text-centered help is-success">{register.message}</p>}

				<Form model='register.data' onSubmit={(val) => this._handleSubmit(val)}
			           validators={{
				           '': {passwordsMatch: (vals) => vals && vals.password === vals.password_confirmation ? 'La confirmación de la contraseña no coincide':undefined }
			           }}
				      onSubmitFailed={(error) => {console.log('error', error)}}>
					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
							<Control.text model=".name" className="input" id="name" autoFocus errors={{isRequired}} validateOn="change" />
							<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
						</div>

						<div className="control">
							<label htmlFor="last_name" className="label">Primer Apellido <span className="small has-text-danger">*</span></label>
							<Control.text model=".last_name" className="input" id="last_name" errors={{isRequired}} validateOn="change" />
							<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
						</div>

						<div className="control">
							<label htmlFor="slast_name" className="label">Segundo Apellido</label>
							<Control.text model=".slast_name" className="input" id="slast_name"/>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="rfc" className="label">RFC <span className="small has-text-danger">*</span></label>
							<Control.text model=".rfc" className="input" id="rfc" errors={{isRequired, isRfc}} validateOn="change" parser={ allUpper }/>
							<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Debes ingresar tu RFC', isRfc: 'RFC inválido. '}} />
						</div>

						<div className="control">
							<label htmlFor="curp" className="label">CURP <span className="small has-text-danger">*</span></label>
							<Control.text model=".curp" className="input" id="curp" errors={{isRequired, maxLength: maxLength(18), isCurp}} validateOn="change" parser={ allUpper }/>
							<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Debes ingresar tu CURP', isCurp: 'CURP inválida.', maxLength: 'CURP inválida.'}} />
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="email" className="label">Email <span className="small has-text-danger">*</span> <small className="has-text-grey">(para ingresar a la plataforma)</small></label>
							<div className="control has-icon has-icon-left">
								<Control.text type="email" model=".email" className="input" placeholder="E-mail" errors={{isRequired, isEmail}} validateOn="change" />
								<span className="icon is-small is-left"><i className={`fa fa-envelope`}/></span>
							</div>
							<Errors className="help is-danger" model=".email" show="touched" messages={{isRequired: 'Debes ingresar tu e-mail', isEmail: 'El email es inválido'}}/>
						</div>

						<div className="control is-expanded">
							<label htmlFor="password" className="label">Contraseña</label>
							<Control.password model=".password" id="password" name="password" className="input" placeholder="Contraseña" errors={{isRequired}} validateOn="change" />
							<Errors className="help is-danger" model=".password" show="touched" messages={{isRequired: 'Tu contraseña es requerida'}} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="password_confirmation" className="label">Contraseña</label>
							<Control.password model=".password_confirmation" id="password_confirmation" name="password_confirmation" className="input" errors={{isRequired}} validateOn="change" />
							<Errors className="help is-danger" model=".password_confirmation" show="touched" messages={{isRequired: 'La confirmación de tu contraseña es requerida'}} />
							<Errors className="help is-danger" model="register.data" show="touched" messages={{passwordsMatch: 'La confirmación de la contraseña no coincide'}} />
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select model=".modality_id" id="modality_id" changeAction={(model,value) => this._changeMod(model,value)} errors={{required}} validateOn="change">
									<option value="" defaultValue>--- Modalidad ---</option>
									{_.map(register.modalities,(option, k) => {
										return <option value={option.id} key={k}>{option.name}</option>
									})}
								</Control.select>
							</div>
							<Errors model=".modality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar una modalidad.' }} />
						</div>

						{listData ?
						<div className="control is-expanded">
							<label htmlFor="roles" className="label">Perfil <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="roles" model=".role_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Perfil ---</option>
									{_.map(roleList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.display ? row.display : row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".role_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El perfil es obligatorio'}} />
						</div>:''}

						{listData ?
						<div className="control is-expanded">
							<label htmlFor="state_id" className="label">Instancia <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="state_id" model=".state_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Instancia ---</option>
									{_.map(statesList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".state_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La instancia es obligatoria'}} />
						</div>:''}

					</div>

					{stateData ?
					<div className="field">
						<div className="control is-expanded">
							<label htmlFor="municipality_id" className="label">Municipio <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="municipality_id" model=".municipality_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Municipio ---</option>
									{_.map(municipalitiesList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".municipality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El municipio es obligatorio'}} />
						</div>
					</div>:''}

					<div className="level">
						<div className="level-left">
							<div className="level-item">
								<button type="button" onClick={() => this.props.reset()} className="button">Regresar</button>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item">
								<Control.button model="register.data" className="button is-black">
									<span>Registrar</span>
								</Control.button>
							</div>
						</div>
					</div>
				</Form>
			</div>
		)
	}

	_handleSubmit(values) {
		this.props.registerUser(values);
		//console.log('values===>', values);
	}

	_changeMod(model,value){
		if(value === '1' || value === '3'){
			this._getConfirm(model,_.toNumber(value));
		}else {
			this.props.change(model,_.toNumber(value));
		}
	}

	_getConfirm(model, value){
		confirmAlert({
			title: '¿Está seguro/segura?',
			message: `¿Estas seguro/segura de ser titular de IMEF?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.change(model,value),
			onCancel: () => this.props.change('register.data.modality_id', '')
		})
	}
}


// WEBPACK FOOTER //
// ./src/elements/register/registerUser.jsx